import { useState, useEffect, useMemo } from 'react';
import { useStorageState } from 'react-storage-hooks';
import { Role, Users } from './types';

//const altwsurl = "https://neuron4web.palermo.enea.it/attrezzappws";
const wsurl = "https://attrezzapp.affarintech.com/wsattrezzapp";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

/*function useLocalStorageState(...args){
  return useStorageState(localStorage, ...args);
}*/

 const addClassToDB = (classes: any,logfunction: (arg0: string) => void,token: any,cb: (arg0: any) => void)=>{
    fetch(wsurl+"/classes",{
            method:"POST",
            headers:{
              "Content-Type":"application/json",
              "Authorization":token
      },
      body: JSON.stringify(classes)  
      }).then((response)=> response.json())
        .then((blob)=>{
              logfunction("Classe inserita");
              if (typeof cb === 'function') {
                cb(blob);
              }
     })
       .catch((error)=>{
            logfunction("Errore "+error);
            if (typeof cb === 'function') {
              cb(error);
            }//setBusy(false);
          });
    };

const postToolToDB = (tool: any,busyfunction: (arg0: boolean) => void,logfunction: (arg0: string) => void, token: string,cb: any) =>{
  fetch(wsurl+"/tools",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        "Authorization":token
      },
      body: JSON.stringify(tool)  
  }).then((response)=> response.json())
      .then((toolsarray)=>{
      busyfunction(false);
      console.log(toolsarray);
      logfunction("tool aggiunto");
                /*toolsarray.forEach( t => {
                  gettoolsimage(t.id);
                });*/
  
  }).catch((error)=>{
      busyfunction(false);
      logfunction("errore "+error);
      //console.log("error "+error);
      //setBusy(false);
  });
  
};

const getPathFromDB = (path:string, busyfunction:any, token:any, cb:any, onerror:any) =>{
  if(typeof busyfunction === 'function')
    busyfunction(true);
  return fetch(wsurl+"/"+path,{
        method:"GET",
        headers:{
          "Accept":"application/json",
          "Authorization":token
        },  
  }).then((response)=> response.json())
        .then((json)=>{
          if(typeof busyfunction === 'function')
            busyfunction(false);
          if(typeof cb === 'function')
            cb(json);
  }).catch((error)=>{
      console.log("error "+error);
      if(typeof busyfunction === 'function')
        busyfunction(false);
      if(typeof onerror === 'function')
        onerror(error);
      
  });
};

const addUserToDB = (user:Users,logfunction:(str:string)=>void,token:string,cb:(blob:any)=>void|null)=>{
  user.id=undefined;
  fetch(wsurl+"/users",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          "Authorization":token
        },
        body: JSON.stringify(user)  
      }).then((response)=> response.json())
        .then((blob:any)=>{
          logfunction("Utente inserito");
          if (typeof cb === 'function') {
            cb(blob);
          }  
          //console.log(blob);
        })
      .catch((error)=>{
        logfunction("Errore in utente "+error);
        if (typeof cb === 'function') {
          cb(error);
        }
        //console.log("error "+error);
        //setBusy(false);
      });
    };

const checkToken = (tkn:string|undefined)=>{
  return (tkn===undefined||tkn===null);
}


export {checkToken, postToolToDB, getPathFromDB, addUserToDB, addClassToDB, wsurl, useWindowDimensions};